module.exports = __webpack_public_path__ + "img/oie-campaign-01.jpg";